import { makeKey, update } from '../../../../utils/reducerOperations';
export function handleLoginProcessStarted(state, payload) {
    return makeKey(
        'SSOLoginApi',
        update(state.loginProcessApi, { isProcessing: true })
    );
}